import { useEffect, useRef, useState } from "react";

import { useMount } from "~/hooks";
import { jotformScript } from "~/utils";

interface JotformIframeProps {
  formId: string | number;
  searchParams?: {
    [key: string]: any;
  };
}

const Iframe = ({ formId, searchParams }: JotformIframeProps) => {
  const ref = useRef<HTMLIFrameElement>(null);
  useMount(() => {
    setTimeout(() => {
      jotformScript(formId);
    }, 400);
    setTimeout(() => {
      if (ref?.current) {
        ref.current.style.opacity = "100";
      }
    }, 3500);
  }, [formId, searchParams]);

  return (
    <iframe
      ref={ref}
      src={`https://form.jotform.com/${formId}?${
        searchParams
          ? new URLSearchParams(searchParams).toString().replaceAll("+", "%20")
          : ""
      }`}
      id={`JotformIFrame-${formId}`}
      title=""
      onLoad={() => {
        window.parent.scrollTo(0, 0);
      }}
      allow="geolocation; microphone; camera"
      allowFullScreen={true}
      className="h-full w-full min-w-full border-none opacity-0"
    ></iframe>
  );
};

const Loading = () => {
  const [showLoading, setShowLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setShowLoading(false);
    }, 3000);
  });

  return (
    <>
      {showLoading && (
        <div
          className="border-t-gray-1000 right-[calc(50%-20px)] top-1/2 h-12 w-12 animate-spin rounded-full border-4 border-gray-200"
          style={{
            position: "absolute",
          }}
        />
      )}
    </>
  );
};

export const JotformIframe = ({ formId, searchParams }: JotformIframeProps) => {
  return (
    <>
      <Loading />
      <Iframe formId={formId} searchParams={searchParams} />
    </>
  );
};
